import React from "react";

type ResultsLayoutProps = {
	children: React.ReactNode;
	className?: string;
	isMobile?: boolean;
};

export function ResultsLayout(props: ResultsLayoutProps) {
	const { children, className = "" } = props;

	return (
		<div className={`grid grid-flow-row-dense gap-16 sf-result-list grid-cols-2 md:grid-cols-4 ${className}`}>
			{children}
		</div>
	);
}
